import { FormSectionHandler } from '../entity.handler';
import { AssetResponse, AssetUpdateRequest, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField} from 'app/shared/components/form-builder';
import { EntityUtils } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    defaultTripLabels?: IdName[];
}

export class AssetLabelsSectionHandler implements FormSectionHandler<AssetResponse, EditorValues> {

    type = 'form';
    icon = ICONS.label;
    bulk = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    properties = ['defaultTripLabels'];

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ASSET.LABELS.${key}`, values);
    }

    applyUpdate(entity: AssetResponse, payload: AssetUpdateRequest): Promise<AssetResponse> {
        return this.admin.applyUpdate(api => api.entities.updateAsset(entity.id, payload));
    }

    async mapEntityToEditor(entity: AssetResponse): Promise<EditorValues> {
        const result = EntityUtils.mergeFields<EditorValues>(this.properties, entity.parameters, {});

        const labels = await this.admin.getCached(`listLabels/${this.ownerId}/true/0/100/name/state=active`, api => api.entities.listLabels(this.ownerId, true, 0, 100, 'name', 'state=active').then(x => x.items));

        result.defaultTripLabels = (entity.defaultTripLabels || []).map(value => {
            const [rootLabel, subLabel] = value.split('/');
            const label1 = labels.find(x => x.label === rootLabel);
            if (label1) {
                const label2 = label1.values.find(x => x.label === subLabel);
                return {
                    id: value,
                    name: [label1.name, label2?.name].filter(x => x).join(': '),
                };
            } else {
                return {
                    id: value,
                    name: value,
                };
            }
        });

        return Promise.resolve(result);
    }

    mapEditorToEntity(entity: AssetUpdateRequest, values: EditorValues): Promise<AssetUpdateRequest> {
        if (values.defaultTripLabels) entity.defaultTripLabels = values.defaultTripLabels.map(x => x.id);
        return Promise.resolve(entity);
    }

    async getFields(entity: AssetResponse): Promise<FormBuilderField[]> {
        const fields = [
            {
                type: 'labelfilter', id: 'defaultTripLabels', title: this.translate('FIELDS.DEFAULT_TRIP_LABELS'), description: this.translate('FIELDS.DEFAULT_TRIP_LABELS_DESC'), required: false, max: 10,
                options: {
                    ownerId: this.ownerId,
                    entity: 'trip',
                    exclusive: true // sub labels are mutually exclusive
                }
            },
        ].filter(x => x);
        return EntityUtils.prepareBulk(!entity, this.properties, fields);

    }

}
